module.exports = __webpack_public_path__ + "static/rss-013f7363449203458c6e4b1a9ac57086.png";